export const BusinessTypes = {
  STORE: 1,
  RENTAL: 2,
}
